<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">密钥信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
        <div style="width:500px">
          <el-form-item label="企业类型" prop="orgType">
            <el-radio-group v-model="form.orgType" style="width:100%">
              <el-radio :label="0">互联互通运营商</el-radio>
              <el-radio :label="1">流量方</el-radio>
              <el-radio :label="2">监管平台</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称" prop="orgId">
            <el-select v-model="form.orgId" filterable remote reserve-keyword style="width:100%" placeholder="请输入搜索关键词" :remote-method="getOrgList">
              <el-option v-for="item in orgList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="企业密钥" prop="orgKey">
            <el-input v-model="form.orgKey" placeholder="请输入企业密钥" style="width:100%" />
          </el-form-item>
          <el-form-item label="消息密钥" prop="smsKey">
            <el-input v-model="form.smsKey" placeholder="请输入消息密钥" style="width:100%" />
          </el-form-item>
          <el-form-item label="初始化向量" prop="initVector">
            <el-input v-model="form.initVector" placeholder="请输入初始化向量" style="width:100%" />
          </el-form-item>
          <el-form-item label="签名密钥" prop="signKey">
            <el-input v-model="form.signKey" placeholder="请输入签名密钥" style="width:100%" />
          </el-form-item>
          <el-form-item label="流量方接口url" prop="url">
            <el-input v-model="form.url" placeholder="请输入流量方接口url" style="width:100%" />
          </el-form-item>
          <el-form-item label="是否对账" prop="reconciliation">
            <el-radio-group v-model="form.reconciliation" style="width:100%">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <div style="width:100%;text-align: center">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Xiugaimiyao',
  components: {},
  data() {
    return {
      form: {
        orgType: '',
        orgId: '',
        orgKey: '',
        smsKey: '',
        initVector: '',
        signKey: '',
        url: '',
        reconciliation: ''
      },
      orgList: [],
      formRules: {
        orgType: [
          { required: true, message: '请选择企业类型', trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: '请选择企业名称', trigger: 'blur' }
        ],
        orgKey: [
          { required: true, message: '请输入企业密钥', trigger: 'blur' }
        ],
        smsKey: [
          { required: true, message: '请输入消息密钥', trigger: 'blur' }
        ],
        initVector: [
          { required: true, message: '请输入初始化向量', trigger: 'blur' }
        ],
        signKey: [
          { required: true, message: '请输入签名密钥', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入流量方接口url', trigger: 'blur' }
        ],
        reconciliation: [
          { required: true, message: '请选择是否对账', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  mounted() {
    this.getOrgList()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
    this.getDetail()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    getDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/getDataDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.form = resp
        }
      })
    },
    getOrgList(val) {
      const data = {
        name: val
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/getOrgName',
        data: data,
        method: 'get',
        callback: resp => {
          this.orgList = resp
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        id: this.id,
        orgType: this.form.orgType,
        orgId: this.form.orgId,
        orgKey: this.form.orgKey,
        smsKey: this.form.smsKey,
        initVector: this.form.initVector,
        signKey: this.form.signKey,
        url: this.form.url,
        reconciliation: this.form.reconciliation
      }
      console.log(data, 1111)
      this.$store.dispatch('form/handle', {
        url: '/setting/changeBusinessKey',
        data: data,
        method: 'post',
        callback: resp => {
          this.$router.go(-1)
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/reviseSecretKey.vue